import React from 'react';
import { RouterProps } from '../shared/types/route.type';
import { AppRoutes } from './routeConstants/appRoutes';
import CompanySetup from '../views/CompanySetup';
import PrivateRoute from '../shared/components/PrivateRoute';
import ActivityDataEntry from 'views/ActivityDataEntry';
import CategoryOneComponent from 'views/ActivityDataEntry/ScopeUpstreamList/CategoryOneComponent';
import Category4and9 from 'views/Scope3/Category4&9';
import Category5 from 'views/Scope3/Category5';
import Category6 from 'views/Scope3/Category6';
import {
  Category2,
  Category3,
  Category7,
  Category8,
  Category10,
  Category11,
  Category12,
  Category13,
  Category14,
  Category15,
} from 'views/Scope3/ManualEmission';

export const companySetupRoutes: RouterProps[] = [
  {
    path: AppRoutes.COMPANY_SETUP,
    element: (
      <PrivateRoute>
        <CompanySetup />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.ACTIVITY_DATA_ENTRY,
    element: (
      <PrivateRoute>
        <ActivityDataEntry />
      </PrivateRoute>
    ),
  },

  {
    path: AppRoutes.CATEGORY_5,
    element: (
      <PrivateRoute>
        <Category5 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_4,
    element: (
      <PrivateRoute>
        <Category4and9 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_6,
    element: (
      <PrivateRoute>
        <Category6 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.SCOPE_3_CATEGORY_1,
    element: (
      <PrivateRoute>
        <CategoryOneComponent />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_2,
    element: (
      <PrivateRoute>
        <Category2 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_3,
    element: (
      <PrivateRoute>
        <Category3 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_7,
    element: (
      <PrivateRoute>
        <Category7 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_8,
    element: (
      <PrivateRoute>
        <Category8 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_10,
    element: (
      <PrivateRoute>
        <Category10 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_11,
    element: (
      <PrivateRoute>
        <Category11 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_12,
    element: (
      <PrivateRoute>
        <Category12 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_13,
    element: (
      <PrivateRoute>
        <Category13 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_14,
    element: (
      <PrivateRoute>
        <Category14 />
      </PrivateRoute>
    ),
  },
  {
    path: AppRoutes.CATEGORY_15,
    element: (
      <PrivateRoute>
        <Category15 />
      </PrivateRoute>
    ),
  },
]; 